import React, { useState, useEffect } from 'react';
import { trackWhatsAppClick } from '@/lib/ga4Tracking.js';
import WhatsAppIcon from '@/components/WhatsAppIcon.jsx';

const WhatsAppButton = () => {
  const [comparatorActive, setComparatorActive] = useState(false);
  const message = encodeURIComponent('Olá! Gostaria de saber mais sobre os produtos Hiperpan');
  const href = `https://wa.me/5551995420336?text=${message}`;

  useEffect(() => {
    const handler = (e) => setComparatorActive(e.detail.active);
    window.addEventListener('comparatorBarChange', handler);
    return () => window.removeEventListener('comparatorBarChange', handler);
  }, []);

  const handleClick = () => {
    // If the tracking module is available, track the click
    if (typeof trackWhatsAppClick === 'function') {
      trackWhatsAppClick('button_flutuante');
    }
  };

  return (
    <div className={`fixed right-6 md:right-8 z-40 group flex items-center justify-center transition-all duration-300 ${comparatorActive ? 'bottom-24 md:bottom-8' : 'bottom-6 md:bottom-8'}`}>
      {/* Tooltip on Desktop */}
      <span className="absolute right-full mr-4 bg-secondary text-secondary-foreground px-4 py-2 rounded-lg text-sm font-bold opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-nowrap shadow-lg pointer-events-none hidden md:block border border-slate-700">
        Fale conosco no WhatsApp
      </span>
      
      {/* WhatsApp Link / Button */}
      <a
        data-gtm="whatsapp"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className="gtm-whatsapp relative flex items-center justify-center bg-[#25D366] hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 w-16 h-16 md:w-20 md:h-20"
        aria-label="Fale conosco no WhatsApp"
      >
        {/* Soft ripple waves, staggered */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-wave-ripple"></span>
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-wave-ripple [animation-delay:1.25s]"></span>


        {/* WhatsApp Icon */}
        <WhatsAppIcon className="w-8 h-8 md:w-10 md:h-10 relative z-10" />
      </a>
    </div>
  );
};

export default WhatsAppButton;